import { LampEasySearch } from "../../models/lamp/lamp";
import { LampEasySearchJsEnv } from "../../models/lamp/lamp_js_env";
import { LampEasySearchRepository } from "../../repositories/lamp/lamp_repository";
import { TypedEvent } from "../../typed_event";
import { LampEasySearchContainer } from "../../views/pc/lamp/lamp_container";

const REFINEMENT_TYPE_LAMP = 2;
const REFINEMENT_LEVEL_ONE = 1;
const PARAMS = new URLSearchParams(window.location.search);
const PARAM_REFINECD_1 = PARAMS.get('refineCD1');

export class LampEasySearchAction {
  static readonly UPDATE_EVENT = new TypedEvent<LampEasySearchJsEnv>();
  private static state: LampEasySearch;
  private static lampEasySearchRepository: LampEasySearchRepository;
  static async init() {
    this.lampEasySearchRepository = new LampEasySearchRepository();
    this.state = new LampEasySearch(new LampEasySearchJsEnv([], '', ''));
    new LampEasySearchContainer(this.state.getModel()); // NOSONAR

    if (PARAM_REFINECD_1 !== null && PARAM_REFINECD_1 !== '') {
      const lampEasySearchJsEnv = await this.lampEasySearchRepository.getRefinementSearchElements(REFINEMENT_TYPE_LAMP, REFINEMENT_LEVEL_ONE, PARAM_REFINECD_1);
      this.state.update(lampEasySearchJsEnv);
      this.state.updateInputWord(PARAM_REFINECD_1);
      this.state.updateSelectedModel(PARAM_REFINECD_1);
      this.UPDATE_EVENT.trigger(this.state.getModel());
    }
  }

  static async getLampModels(searchWord: string) {
    // ランプ検索エリアの「型番」の入力欄に何も入力していない時は「候補ワード」には何も表示させない。
    let lampEasySearchJsEnv = searchWord
      ? await this.lampEasySearchRepository.getRefinementSearchElements(REFINEMENT_TYPE_LAMP, REFINEMENT_LEVEL_ONE, searchWord)
      : new LampEasySearchJsEnv([], '', '')
    this.state.update(lampEasySearchJsEnv);
    this.state.updateInputWord(searchWord);
    this.UPDATE_EVENT.trigger(this.state.getModel());
    const WindowScrollBar = window._scrollBar;
    const modelSearchWords = document.getElementById('modelsearch_words');
    if(modelSearchWords){
      try {
          new WindowScrollBar(modelSearchWords);
      } catch (e) {
        /* ... */
      }
    }
  }

  static updateSelectedModel(selectedModel: string) {
    this.state.updateSelectedModel(selectedModel);
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }
}
